import { useContext } from "react"

import BeautyCampaignFormStepTwo from "./components/beautyCampaignFormStepTwo/beautyCampaignFormStepTwo"
import FashionCampaignFormStepTwo from "./components/fashionCampaignFormStepTwo/fashionCampaignFormStepTwo"
import { CampaignFormContext } from "pages/campaigns/campaignForm/campaignForm.context"
import { CampaignFormStepTwoContextProvider } from "./campaignFormStepTwo.context"

const CampaignFormStepTwo = () => {
  const { brand } = useContext(CampaignFormContext)

  return (
    <CampaignFormStepTwoContextProvider>
      {brand.isCategoryBeauty ? <BeautyCampaignFormStepTwo /> : <FashionCampaignFormStepTwo />}
    </CampaignFormStepTwoContextProvider>
  )
}

export default CampaignFormStepTwo
